import InterviewHead from 'components/Interview/Head';
import { FC, useContext, useMemo } from 'react';
import { ReviewPageContext } from '.';

const Head: FC = () => {
  const { interview } = useContext(ReviewPageContext);

  const mentorName: string = useMemo(() => {
    if (
      interview?.mentorship?.mentor?.firstName &&
      interview.mentorship.mentor.lastName
    ) {
      return `${interview.mentorship.mentor.firstName} ${interview.mentorship.mentor.lastName}`;
    }
    return 'Entretien';
  }, [interview]);
  return (
    <InterviewHead
      backTo="/mentee/mentorship/management/interviews"
      interview={interview}
      title={mentorName}
      variant="mentee"
    />
  );
};

export default Head;
